<template>
    <MainContent title="Venta de abonos">
        <template v-slot:header>
            <div class="d-md-flex justify-content-md-between">
                <div class="my-3" v-if="paso == 1">
                    <template v-if="permisos['abonos.configurar']">
                        <Button class="mr-2" @click="$modal.show('liberar-asientos-abonados');">
                            LIBERAR ASIENTOS NO RENOVADOS
                        </Button>
                        <liberarAsientosAbonados @close="$modal.hide('liberar-asientos-abonados')"></liberarAsientosAbonados>
                    </template>
                    
                    <router-link :to="{ name: 'back.abonos.precios' }" class="btn btn-primary mr-2" v-if="permisos['abonos.configurar']">
                        <i class="fas fa-money-check-alt"></i> Configurar abonos
                    </router-link>
                    <router-link :to="{ name: 'back.abonos.informe' }" class="btn btn-primary mr-2" v-if="permisos['abonos.informe']"><i class="fas fa-chart-bar"></i>VENTAS</router-link>

                    <template v-if="!manager.lfp && permisos['abonos.configurar']">
                        <router-link :to="{ name: 'back.abonos.bloquear-asientos'}" class="btn btn-primary mr-2">
                            <i class="fas fa-lock"></i> Gestor butacas
                        </router-link>
                        <Button @click="$modal.show('opciones-bloqueos');">
                            Opciones de bloqueos
                        </Button>
                        <OpcionesBloqueos @close="$modal.hide('opciones-bloqueos')"></OpcionesBloqueos>
                    </template>
                    <router-link v-if="permisos['abonos.configurar']" :to="{ name: 'back.abonos.campos-personalizados', params:{ lista_id: lista_id } }" class="btn btn-primary ml-2">
                        Campos personalizados
                    </router-link>
                </div>
                <div class="my-3" v-else>
                    <Button
                        class="mr-3"
                        @click="goTo(1)"
                    >
                        Cambiar zona
                    </Button>
                </div>
            </div>
        </template>
        <template v-slot:content>
            <transition name="fade" mode="out-in" v-if="permisos['abonos.vender']">
                <div key="1" v-if="paso == 1" id="paso-1">
                    <PasoUnoComponent v-on:goTo="finalizarPasoUno" :precios="precios" @setZonas="setZonas"></PasoUnoComponent>
                </div>
                <div key="2" v-if="paso == 2" id="paso-2">
                    <PasoDosComponent
                        :abono_seleccionado="abono_seleccionado"
                        :datos_compradores="datos_compradores"
                        :zona="zona_seleccionada"
                        :zonas="zonas"
                        v-on:goTo="finalizarPasoDos"
                        v-on:resetDatos="resetDatos"
                    ></PasoDosComponent>
                </div>
            </transition>
            <transition name="fade" mode="out-in">
                <div key="3" v-if="paso >= 3" id="paso-3">
                    <PasoTresComponent 
                        :datos_compradores="datos_compradores" 
                        v-on:goTo="finalizarPasoTres" 
                        :precios="precios" 
                        :zona="zona_seleccionada" 
                        @volver="volver" 
                        v-on:actualizar="datos => datos_compradores = datos"
                        :disabled="paso >= 4"
                    />
                </div>
            </transition>
            <transition name="fade" mode="out-in">
                <div key="4" v-if="paso >= 4" id="paso-4">
                    <PasoCuatroComponent :datos_compradores="datos_compradores" :datos_compra="datos_compra" v-on:reiniciar="reiniciar"></PasoCuatroComponent>
                </div>
            </transition>
        </template>
    </MainContent>
</template>

<script>
import PasoUnoComponent from '@/components/backend/stepper/abonos/PasoUnoComponent';
import PasoDosComponent from '@/components/backend/stepper/abonos/PasoDosComponent';
import PasoTresComponent from '@/components/backend/stepper/abonos/PasoTresComponent';
import PasoCuatroComponent from '@/components/backend/stepper/abonos/PasoCuatroComponent';
import liberarAsientosAbonados from './modals/LiberarAsientosAbonados';
import MainContent from "@/components/backend/components/MainContent";
import OpcionesBloqueos from "./modals/OpcionesBloqueos";

export default {
    data() {
        return {
            paso: 1,
            zona_seleccionada: null,
            zonas: null,
            datos_compradores: [],
            precios: null,
            datos_compra: null,
            abono_seleccionado: null
        }
    },
    created() {
        this.getPrecios();
    },
    computed: {
        permisos() {
            return this.$store.getters.getPermisos;
        },
        query_zona() {
            if(this.$route.query.zona == undefined) {
                this.goTo(1);
            }
            return this.$route.query.zona;
        },
        manager() {
            return this.$store.getters.getFooter;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        lista_id() {
            return this.$store.getters.getListaId;
        }
    },
    methods: {
        reiniciar() {
            this.paso = 1,
            this.zona_seleccionada = null,
            this.datos_compradores = [],
            this.datos_compra = null
        },
        scrollTo(paso) {
            this.$scrollTo(paso, 100)
        },
        goTo(paso) {
            if(paso < this.paso) {
                if(paso == 1) {
                    this.datos_compradores = [];
                    this.paso = paso;
                }
            }
        },
        finalizarPasoUno(paso, zona, abonado) {
            if(zona) {
                this.zona_seleccionada = zona;

                if(abonado) {
                    this.$router.push({name: 'back.abonos.index', query: {zona: zona.id, n_abonado_antiguo: abonado.n_abonado_antiguo}});
                }
            }
            this.paso = paso;

            this.$nextTick(function() {
                this.scrollTo('#paso-' + paso);
            });
        },
        finalizarPasoUnoTeatros(paso, datos_compradores, zona) {
            this.datos_compradores = datos_compradores;
            this.paso = paso;

            if(zona) {
                this.abono_seleccionado = this.datos_compradores;
                this.datos_compradores = [];                    
                this.zona_seleccionada = zona;
            }
        },
        finalizarPasoDos(paso, datos) {
            if(datos) {
                this.datos_compradores = Object.assign({}, datos);
            }
            this.paso = paso;

            this.$nextTick(function() {
                this.scrollTo('#paso-' + paso);
            });
        },
        finalizarPasoTres(paso, datos_compra) {
            this.datos_compra = datos_compra;

            if(this.datos_compra.metodo_pago.valor == 9) {
                for (var index in this.datos_compradores) {
                    var plazos = [];
                    this.datos_compradores[index].plazos = true;
                    this.datos_compradores[index].iban = this.datos_compra.iban;
                    this.datos_compradores[index].titular_cuenta = this.datos_compra.titular_cuenta;

                    var precio_reserva = 50;
                    var numero_plazos = 2;
                    var precio = this.datos_compradores[index].precio.precio;

                    if(this.datos_compradores[index].descuento_aplicado) {
                        var cantidad_descuento = (this.datos_compradores[index].descuento_aplicado / 100) * precio;

                        precio = precio - cantidad_descuento;
                    }

                    if(this.datos_compradores[index].descuento_integro) {
                        precio = precio - this.datos_compradores[index].descuento_integro;
                    }

                    var infos = ['5 Agosto', '6 Septiembre'];

                    plazos.push({
                        importe: precio_reserva,
                        gastos: this.datos_compradores[index].precio.price_management_taquilla,
                        gastos_internos: this.datos_compradores[index].precio.price_management_taquilla_interno,
                        pagado: 0,
                        fecha_pago: null,
                        informacion: 'Reserva de asiento'
                    });

                    var precio_sin_descuento = this.datos_compradores[index].precio.precio;
                    precio_sin_descuento = precio_sin_descuento - precio_reserva;
                    var plazos_sin_descuento = precio_sin_descuento / numero_plazos;


                    var importe_restante = precio - precio_reserva;
                    var importe_plazos = importe_restante / numero_plazos;

                    for (var i = 0; i < numero_plazos; i++) { 
                        plazos.push({
                            importe: importe_plazos,
                            gastos: 0,
                            gastos_internos: this.datos_compradores[index].precio.price_management_taquilla_interno,
                            pagado: 0,
                            fecha_pago: null,
                            informacion: infos[i],
                            descuento_aplicado: plazos_sin_descuento - importe_plazos
                        });
                    }

                    this.datos_compradores[index].plazos_pendientes = plazos;
                }
            }

            this.paso = paso;

            this.$nextTick(function() {
                this.scrollTo('#paso-' + paso);
            });
        },
        getPrecios() {
            const params = {
                filters : {},
                lista_id: this.lista_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.precios.index'), params).then(res => {
                this.precios = res.data;

                for (var i in this.precios) {
                    this.precios[i].unidades = 0;
                }
            });
        },
        liberarAsientosAbonados() {                
            const params = {
                filters : {},
                lista_id: this.lista_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.lista.liberar.asientos'), params).then(res => {
                this.$toast.success(res.data.message);
            });
        },
        volver() {
            this.borrarSesion(sessionStorage.getItem('session_id'));
            this.goTo(1);
        },
        borrarSesion(session_id) {
            const params = {
                filters: {
                    session_id: session_id,
                    tid: this.configuracion.hash_teatro
                },
                session_id: session_id,
                tid: this.configuracion.hash_teatro
            }

            this.$store.dispatch(this.config.getVuexAlias('front.sesion.delete'), params);
        },
        resetDatos(new_zona) {
            this.datos_compradores = [];
            this.zona_seleccionada = new_zona;
        },
        setZonas(zonas) {
            this.zonas = zonas;
        }
    },
    components: {
        MainContent, PasoUnoComponent, PasoDosComponent, PasoTresComponent, PasoCuatroComponent, liberarAsientosAbonados, OpcionesBloqueos
    }
}
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
